function resizeNav() {
    var newHeight = window.innerHeight;
    $('.header-mobile-content').css('max-height', newHeight );
}

$(document).ready(function () {
    
    $(window).on('resize', function () {
        resizeNav();
    });
    

    $("#scrolltop").on('click', function() {
        window.scrollTo(0, 0);
    });
    //dropdown function
    $('.menu-top .menu-item-has-children').not('.menu-item-has-mega').each(function () {
        $(this).children('a').addClass('dropdown-link');
    });
    $('.dropdown-link').each(function () {
        $(this).click(function (e) {
            e.preventDefault();

            $('.dropdown-link').next().not($(this).next()).removeClass('dropdown');
            $('.dropdown-link').next().not($(this).next()).slideUp();
            if ($(this).next().hasClass('dropdown')) {
                $(this).next().removeClass('dropdown');
                $(this).next().slideUp();
            } else {
                $(this).next().addClass('dropdown');
                $(this).next().slideDown();
            }
        });
    });
    // //close dropdown if click on page
    $(document).mouseup(function (e) {
        var container = $('.sub-menu, .dropdown-link');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.dropdown-link').next().removeClass('dropdown');
            $('.dropdown-link').next().slideUp();
        }
    });

    $('.mobile--inner--wrapper .menu-item-has-children').not('.menu-item-has-mega').each(function () {
        $(this).addClass('acc-submenu');
    });
    $('.mobile--inner--wrapper .menu-item-has-children').not('.menu-item-has-mega').each(function () {
        $(this)
            .children('a')
            .click(function (e) {
                e.preventDefault();
                $(this).toggleClass('rotate');
                $(this).next().toggleClass('acc--menu--open');
                $(this).next().slideToggle('slow');
            });
    });

    // $('.hamburger--wrapper').on('click', function () {
    //     $(this).find('.hamburger').toggleClass('hamburger-close');
    // });
    $('.hamburger--wrapper').click(function () {
        $('.hamburger--wrapper .hamburger').prop('disabled', true);

        //mobile menu animation
        if (!$('.header-mobile-content').hasClass('header--open')) {
            //burger toggle animation
            $('.hamburger--wrapper .hamburger').addClass('hamburger-close');
            $('body').addClass('nav--open');

            //open menu
            $('.header-mobile-content').addClass('header--open').removeClass('header--closed');
            $('html, body').css({
                overflow: 'hidden',
            });
        } else {
            //burger toggle animation
            $('.hamburger--wrapper .hamburger').removeClass('hamburger-close');
            $('body').removeClass('nav--open');

            //close menu
            $('.header-mobile-content').removeClass('header--open').addClass('header--closed');
            $('html, body').css({
                overflow: 'visible',
            });

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }

        setTimeout(function () {
            // enable click after 1 second
            $('.hamburger--wrapper .hamburger').prop('disabled', false);
        }, 500); // .5 second delay
    });

    // //close menu if click on page
    $(document).mouseup(function (e) {
        var container = $('.header--open, .hamburger--wrapper');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-mobile-content').removeClass('header--open');
            $('.hamburger--wrapper .hamburger').removeClass('hamburger-close');
            $('html, body').css({
                overflow: 'visible',
            });
            $('body').removeClass('nav--open');

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }
    });

    //hide navbar on scroll
    $(function () {
        var lastScrollTop = 0,
            delta = 5;
        $(window).scroll(function () {
            var nowScrollTop = $(this).scrollTop();
            var scroll = $(window).scrollTop();
           
            if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
                if (nowScrollTop > lastScrollTop) {
                    // SCROLLING DOWN
                    if (scroll >= 400) {
                        $('.site-header').removeClass('nav-down').addClass('nav-up');
                    }
                    // if (scroll >= 200) {
                    //     $('.site-header').removeClass('top');
                    // }
                } else {
                    // SCROLLING UP
                    var isWpc = $('body').hasClass('page-template-page-wpc');
                    var isWpcContact = $('body').hasClass('page-template-page-wpc-contact');
                    var isReferenzen = $('body').hasClass('single-referenzen');

                    if (isWpc || isWpcContact || isReferenzen) {
                        if (lastScrollTop <= 200) {
                            $('.site-header').removeClass('nav-up').addClass('nav-down');
                        }
                    } else {
                        $('.site-header').removeClass('nav-up').addClass('nav-down');
                    }
                }
                lastScrollTop = nowScrollTop;
            }
        });
    });
});